<template>
  <v-content>
    <v-slide-x-transition mode="out-in">
      <router-view></router-view>
    </v-slide-x-transition>
    <v-bottom-navigation grow fixed color="pink" height="48" app>
      <v-btn v-blur to="/home/ini">
        <v-icon large>mdi-home</v-icon>
      </v-btn>
      <v-btn v-blur to="/home/chat">
        <v-icon large>mdi-chat</v-icon>
      </v-btn>
      <v-btn v-blur to="/home/friends">
        <v-icon large>mdi-account-group</v-icon>
      </v-btn>
      <v-btn v-blur to="/home/account">
        <v-icon large>mdi-account</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-content>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
.v-bottom-navigation--fixed {position: fixed !important;}

.v-item-group.v-bottom-navigation .v-btn {height: inherit !important;}
</style>